import { render, staticRenderFns } from "./QuizzChoicesItem.vue?vue&type=template&id=79b8cc97&"
import script from "./QuizzChoicesItem.vue?vue&type=script&lang=ts&"
export * from "./QuizzChoicesItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports